import { ChangeDetectionStrategy, Component, Inject, Input, model, Signal, signal, ViewChild, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { IIstatComune } from 'src/app/modules/istat-comuni/istat-comuni.model';
import { InputSelectComponent } from "../../../../shared/components/inputs/input-select/input-select.component";
import { InputSelectLuogoAreaComponent} from "../input-select-luogo-area/input-select-luogo-area.component";
import { LuogoInput } from '../../models/luoghi.model';
import { IIstatRegione } from 'src/app/modules/istat-regioni/istat-regioni.model';


@Component({
  selector: 'app-input-group-luogo-area',
  standalone: true,
  imports: [ InputSelectComponent, InputSelectLuogoAreaComponent,CommonModule],
  templateUrl: './input-group-luogo-area.component.html',
  styleUrl: './input-group-luogo-area.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputGroupLuogoAreaComponent {
  @Input() form: FormGroup;
  @Input() generalComuni?:Signal<IIstatComune[]>;
  @Input() generalRegioni?:Signal<IIstatRegione[]>;
  @Input() selectedUserEnabledLocation:{ [key: string]: any } = {};
  @Input() delegheRegioni=new Array()
  @Input() delegheComuni=new Array()
  checkCaricamentoLuoghi:boolean=false
  datiRegione:LuogoInput[]=new Array()
  datiComune:LuogoInput[] = new Array()
  luogoRegioniSignal: WritableSignal<LuogoInput[]> = signal([]);
  luogoComuniSignal: WritableSignal<LuogoInput[]> = signal([]);
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  @ViewChild('luogoInput') luogoInput: any;

  constructor(private readonly fb: FormBuilder){
    this.form = this.fb.group({});
  }

  ngOnInit(){

    if(this.generalRegioni){
  
           let firstDataRegioni:LuogoInput[]=new Array()

           this.generalRegioni().forEach((el:IIstatRegione)=>{
      
                if(!this.datiRegione.some(regione => regione.id === el.istatRegione && regione.denominazione === el.denominazioneRegione)){
             
                  this.datiRegione.push({"id":el.istatRegione , "denominazione":el.denominazioneRegione.toUpperCase()})

                  if(this.selectedUserEnabledLocation && this.selectedUserEnabledLocation['istatRegione'] && this.selectedUserEnabledLocation['istatRegione'].includes(el.istatRegione)){

                    firstDataRegioni.push({"id":el.istatRegione , "denominazione":el.denominazioneRegione.toUpperCase()})

                  }

                }
          
          })

          this.luogoRegioniSignal.set(firstDataRegioni)

    }

    if(this.generalComuni){

      let firstDataComuni:LuogoInput[]=new Array()

      this.generalComuni().forEach((el:IIstatComune)=>{

           if(!this.datiComune.some(comune => comune.id === parseInt(el.istatComune) && comune.denominazione === el.denominazione)){
           
             this.datiComune.push({"id":parseInt(el.istatComune) , "denominazione":el.denominazione.toUpperCase()})

             if(this.selectedUserEnabledLocation && this.selectedUserEnabledLocation['istatComune'] && this.selectedUserEnabledLocation['istatComune'].includes(el.istatComune)){

               firstDataComuni.push({"id":parseInt(el.istatComune) , "denominazione":el.denominazione.toUpperCase()})

             }
           
           }
     
     })

     this.luogoComuniSignal.set(firstDataComuni)  

    }
    this.checkCaricamentoLuoghi=true

  }


}
